module.exports = __webpack_public_path__ + "img/achievement_26.84b1617d.png";